

export class CustomModalPopUpModel {

      id: string;
      title: string;
      button1: string;
      button2: string;
      noButtons?= false;
      large?= true;
      upperCross?= true;
      constructor() {
      }
}




// WEBPACK FOOTER //
// ./src/app/components/custom-modal-pop-up/custom-modal-pop-up.model.ts